import { IPictureBaseModel, PictureBaseModel } from "../picture/picture.model";

export interface IPropertyEnvironmentPicture extends IPictureBaseModel {
}

export class PropertyEnvironmentPicture extends PictureBaseModel implements IPropertyEnvironmentPicture {
    constructor(option: IPropertyEnvironmentPicture) {
        super(option);
    }
}

export interface IPropertyEnvironmentPictureStorage {
    UrlPicture?:string
    PictureNumber?: Number
}

export class PropertyEnvironmentPictureStorage implements IPropertyEnvironmentPictureStorage {
    UrlPicture?:string
    PictureNumber?: Number
    constructor(option: IPropertyEnvironmentPictureStorage) {
        this.UrlPicture = option.UrlPicture
        this.PictureNumber = option.PictureNumber
    }
}